"use client";
import React from 'react'
import Reveal from "./Reveal";
import {
  GraduationCap,
  FileText,
  Microscope,
  BarChart3,
  Network,
  FlaskConical,
} from "lucide-react";


const Careers = () => {
    const careers = [
        {
            title: "Academic Researcher / Faculty",
            icon: GraduationCap,
            desc: "Lead research and teach at universities and institutions",
        },
        {
            title: "Policy Analyst & Advisor",
            icon: FileText,
            desc: "Shape evidence-based public policy at national level",
        },
        {
            title: "Industry Research Specialist",
            icon: Microscope,
            desc: "Drive R&D innovation within leading corporations",
        },
        {
            title: "Evidence-Based Consultant",
            icon: BarChart3,
            desc: "Guide organisations with deep domain expertise",
        },
        {
            title: "Skill Ecosystem Leader",
            icon: Network,
            desc: "Lead skill development programs and think tanks",
        },
        {
            title: "R&D Programme Manager",
            icon: FlaskConical,
            desc: "Oversee research programmes across verticals",
        },
    ];
    return (
        <section className="py-14 md:py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center mb-12">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <div className="w-8 h-0.5 bg-[#FFA201]" />
                        <span className="text-[#0475B3] text-xs font-black uppercase tracking-widest">Career Prospects</span>
                        <div className="w-8 h-0.5 bg-[#FFA201]" />
                    </div>
                    <h2 className="text-4xl font-black text-[#081E2D] mb-2">Where a Ph.D. Takes You</h2>
                    <p className="text-gray-500 text-md">Open doors that a Master's degree simply cannot.</p>
                </Reveal>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {careers.map((c, i) => {
                        const Icon = c.icon;

                        return (
                            <Reveal key={c.title} delay={i * 80}>
                                <div className="group flex items-start gap-4 bg-gray-50 hover:bg-[#EBF5FB] rounded-md p-5 border border-transparent hover:border-[#0475B3]/20 transition-all duration-300">
                                    <div className="shrink-0">
                                        <Icon
                                            size={32}
                                            className="text-[#0475B3] group-hover:scale-110 transition-transform duration-300"
                                        />
                                    </div>

                                    <div>
                                        <div className="font-black text-[#081E2D] text-lg mb-1 group-hover:text-[#0475B3] transition-colors">
                                            {c.title}
                                        </div>
                                        <div className="text-gray-500 text-md leading-normal">
                                            {c.desc}
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default Careers